import { Pipe, PipeTransform } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { productSelectors } from '../../../product/product.selectors'
import { SaleItem } from '../sale-item'
import { Observable } from 'rxjs'
import { SaleItemPriceDetails, SaleItemService } from '../sale-item.service'
import { map, take } from 'rxjs/operators'
import moment from 'moment-mini'

@Pipe({
  name: 'getSaleItemRentalProductPrice'
})
export class GetSaleItemRentalProductPricePipe implements PipeTransform {
  productEntities$ = this.store.select(productSelectors.selectEntities)

  constructor(
    private store: Store<AppState>,
    private saleItemService: SaleItemService
  ) {}

  transform(saleItem: SaleItem): Observable<SaleItemPriceDetails> {
    return this.saleItemService.getSaleItemProductPriceDetails$(saleItem).pipe(
      take(1),
      map((priceForMember) => {
        const rentEndDate = moment(saleItem.params?.rentEndDate)
          .clone()
          .add(1, 'minute')

        const duration = moment.duration(
          moment(rentEndDate).diff(moment(saleItem.params?.rentStartDate))
        )

        const hours = duration.asHours()

        priceForMember.memberPrice = +(
          priceForMember.memberPrice * hours
        ).toFixed(2)

        priceForMember.price = +(priceForMember.price * hours).toFixed(2)

        return priceForMember
      })
    )
  }
}
